import { Paragraph, Ruler, Skeleton, tokens } from '@welbe/web-design-system';
import { useContext } from 'react';
import { FiChevronRight, FiInfo } from 'react-icons/fi';
import {
	HealthRiskAssessmentContext,
	HealthRiskAssessmentContextType,
} from 'Views/HealthRiskAssessment/HealthRiskAssessment.context';
import {
	ActivitiesTypes,
	RiskAssessmentGroupTypes,
	TabType,
} from '../../HealthRiskAssessment.types';
import {
	Card,
	CardInfo,
	CardTitle,
	Container,
	GridContainer,
	InfoLink,
	LoadingContainer,
} from './RiskGroups.styles';

type RiskGroupProps = {
	onChangeTab: (group: RiskAssessmentGroupTypes, tab: TabType) => void;
};

export const RiskGroup = ({ onChangeTab }: RiskGroupProps): JSX.Element => {
	const { assignedGroups, isLoading } =
		useContext<HealthRiskAssessmentContextType>(HealthRiskAssessmentContext);

	const renderAssignedActivities = (
		activities: ActivitiesTypes[] | undefined,
	) => {
		const assignedActivities =
			activities?.filter((item) => item.activityAssigned === true) || [];

		return assignedActivities.length;
	};

	if (isLoading) {
		return (
			<LoadingContainer>
				<Skeleton width="30%" height="100%" />
				<Skeleton width="30%" height="100%" />
				<Skeleton width="30%" height="100%" />
			</LoadingContainer>
		);
	}

	if (!assignedGroups?.length) {
		return (
			<Container>
				<FiInfo color={tokens.color_gray_dark} />
				<Paragraph fontWeight="500">No se encontraron resultados</Paragraph>
			</Container>
		);
	}

	return (
		<GridContainer>
			{assignedGroups?.map((group) => (
				<Card key={group.id}>
					<CardTitle>{group.name}</CardTitle>
					<Ruler borderColor={tokens.color_gray_medium} margin="10px 0" />
					<CardInfo>
						<Paragraph fontWeight="500">Población:</Paragraph>
						<InfoLink onClick={() => onChangeTab(group, 'population')}>
							{group.employeesCount} colaboradores
							<FiChevronRight fontSize={22} />
						</InfoLink>
					</CardInfo>
					<Ruler borderColor={tokens.color_gray_medium} margin="10px 0" />
					<CardInfo>
						<Paragraph fontWeight="500">Programa de:</Paragraph>
						<InfoLink onClick={() => onChangeTab(group, 'activityProgram')}>
							{renderAssignedActivities(group.activities)} actividades
							<FiChevronRight fontSize={22} />
						</InfoLink>
					</CardInfo>
				</Card>
			))}
		</GridContainer>
	);
};
